import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useConfirmationStore } from "@/app/store"
import { Button, Modal } from "@/shared/components"
import { Delete } from "../ui/icons/custom"

export function ConfirmationProvider() {
  // Helpers
  const { t } = useTranslation("common")

  // Store
  const { show, closeModal, onConfirm } = useConfirmationStore()

  // Effect
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => event.key === "Escape" && closeModal()
    document.addEventListener("keydown", handleEsc)
    return () => document.removeEventListener("keydown", handleEsc)
  }, [closeModal])

  return (
    <>
      {show != null && (
        <Modal title={show?.title ?? ""} show={show != null} onClose={closeModal} classNames={{ modal: "!w-fit" }}>
          <div className="flex flex-col items-center justify-center gap-5">
            <Delete />
            <span>{show!.message}</span>
          </div>
          <div className="flex flex-col gap-3 md:flex-row">
            <Button
              loading={show.buttonLoading}
              onClick={onConfirm}
              className="min-w-40 rounded-lg border border-[#DB27773D] bg-[#DB277714] p-3 text-[#DB2777] text-base/[1] ring-Red hover:bg-[#DB277714]/20 active:bg-red-200"
            >
              {show.confirmationButtonText || t("delete")}
            </Button>
            <Button
              type="button"
              variant="outlined"
              onClick={closeModal}
              className="min-w-36 rounded-lg border border-[#D6DEE7] bg-white p-3 text-base/[1] ring-zinc-500 hover:bg-coolGray-100/50 hover:bg-zinc-100 active:bg-zinc-200"
            >
              {t("cancel")}
            </Button>
          </div>
        </Modal>
      )}
    </>
  )
}
